// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-question-menu {
  position: absolute;
  top: 10px;
  right: 20px;
}
.fi-form-question-menu .question-setting-menu-trigger {
  width: 30px;
  min-width: 30px;
  border-radius: 50%;
  height: 30px;
  line-height: 40px;
  padding: 0;
}
.fi-form-question-menu .question-setting-menu-trigger .mat-icon {
  font-size: 14px;
  line-height: 30px;
}

.form-question-setting-menu .mat-icon.fi-more-menu-item-checked {
  vertical-align: middle;
  line-height: 24px;
  text-align: center;
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-question-menu/fi-form-question-menu.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AACJ;AAAI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;AAER;AADQ;EACI,eAAA;EACA,iBAAA;AAGZ;;AAGI;EACI,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAAR","sourcesContent":[".fi-form-question-menu {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 20px;\r\n    .question-setting-menu-trigger {\r\n        width: 30px;\r\n        min-width: 30px;\r\n        border-radius: 50%;\r\n        height: 30px;\r\n        line-height: 40px;\r\n        padding: 0;\r\n        .mat-icon {\r\n            font-size: 14px;\r\n            line-height: 30px;\r\n        }\r\n    }\r\n}\r\n\r\n.form-question-setting-menu {\r\n    .mat-icon.fi-more-menu-item-checked {\r\n        vertical-align: middle;\r\n        line-height: 24px;\r\n        text-align: center;\r\n        font-size: 24px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
